import React from "react";
import style from "./style.module.css";
import styleButton from '../../components/Button/Button.module.css'

export default function PresetBlock(props) {
  const { title, description, id, editPreset, clonePreset, deletePreset } = props;
  return (
    <div className={style.preset_block}>
      <h4 className="mini-title">{title}</h4>
      {!!description && (
        <p className="sub-title mt-2">{description}</p>
      )}
      <div className={style.actions}>
        <button
          type="button"
          className={`${styleButton.button_primary}`}
          onClick={() => {
            editPreset(id);
          }}
        >
          <span>Editar</span>
        </button>
        <button
          type="button"
          className={`${styleButton.button_ghost} ml-2`}
          onClick={() => {
            clonePreset(id);
          }}
        >
          <span>Clonar</span>
        </button>
        <button
          type="button"
          className={`${styleButton.button_ghost_error} ml-2`}
          onClick={() => {
            deletePreset(id);
          }}
        >
          <span>Apagar</span>
        </button>
      </div>
    </div>
  )
}